import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthenticationRequestService } from '@services/auth/authentication.request.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  pending = false;
  sent = false;
  error = false;

  form = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.email, Validators.required]),
  });

  constructor(
    private bus: BusService,
    private events: EventsService,
    private authReq: AuthenticationRequestService,
  ) {}

  success() {
    setTimeout(() => {
      this.pending = false;
      this.sent = true;
      this.error = false;
    }, 2000);
  }

  failure() {
    this.pending = false;
    this.error = true;
  }

  submit() {
    this.pending = true;
    this.bus.publish(
      this.events.requested.action.user.forgotPassword,
      this.form.controls.email.value,
    );
  }

  subscribe() {
    this.bus.subscribe(
      this.events.received.action.user.forgotPassword.success,
      this.success,
      this,
    );
    this.bus.subscribe(
      this.events.received.action.user.forgotPassword.failure,
      this.failure,
      this,
    );
  }

  unsubscribe() {
    this.bus.unsubscribe(
      this.events.received.action.user.forgotPassword.success,
      this.success,
    );
    this.bus.unsubscribe(
      this.events.received.action.user.forgotPassword.failure,
      this.failure,
    );
  }

  ngOnInit() {
    this.subscribe();
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
}
